import { css } from 'glamor'

css.global('html, body', {
  fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSmoothing: 'antialiased',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  textRendering: 'optimizeLegibility',
  padding: 0,
  margin: 0
})

css.global('html', {
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  overflow: 'hidden'
})

css.global('body', {
  height: '100%',
  overflow: 'auto',
  WebkitOverflowScrolling: 'touch'
})

css.global('#root', {
  height: '100%'
})



// WEBPACK FOOTER //
// ./src/global-styles.js